import 'styled-components/macro';
import React from 'react';

import { PickerButton } from './StyledElements';
import { formatTimeSlot, Slot } from './service';

interface Props {
    selectedSlot: null | Slot;
    onSelect: (slot: Slot) => void;
    slots: Slot[];
    timezoneId: string;
    locale: string;
}

export const TimePicker = ({ slots, onSelect, selectedSlot, timezoneId, locale }: Props): React.ReactElement => {
    let startTime,
        endTime = '';
    let isPicked;

    return (
        <>
            {slots.map((slot) => {
                ({ startTime, endTime } = formatTimeSlot({ start: slot.start, end: slot.end }, timezoneId, locale));
                isPicked = selectedSlot && selectedSlot.start === slot.start;

                return (
                    <PickerButton
                        key={slot.start}
                        textAlign="center"
                        isSelected={isPicked}
                        disabled={isPicked}
                        ariaPressed={isPicked}
                        onClick={() => onSelect(slot)}
                    >
                        {startTime} - {endTime}
                    </PickerButton>
                );
            })}
        </>
    );
};
